import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem4,
    GridItem6,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorTextRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import corretoraValoresList from '../../../business-rules/List/Investimentos/corretoraValoresList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisContaInvestimentos,
} from './CadastroServiceContaInvestimentos'



const CadastroFormContaInvestimentos = ({ familiar, values, handleChange }) => {

    processaRegistrosDefaultIniciaisContaInvestimentos(values, familiar)

    return (
        <FieldArray name="contasInvestimentos">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.contasInvestimentos && values.contasInvestimentos.filter(containvestimento => containvestimento.familiar === familiar).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.contasInvestimentos?.map((item, ind) => {
                            return item.familiar === familiar ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem12>
                                        <GridContainer>
                                            <GridItem4>
                                                <TextFieldNumberSelect
                                                    name={`contasInvestimentos[${ind}].instituicaoFinanceira`}
                                                    label={LABEL.instituicaoFinanceira}
                                                    value={item.instituicaoFinanceira || ''}
                                                    onChange={handleChange}
                                                    list={corretoraValoresList()}
                                                />
                                            </GridItem4>
                                            <GridItem7>
                                                {item.instituicaoFinanceira && (
                                                    <GridContainer>
                                                        <GridItem6>
                                                            <TextValidatorTextRequired
                                                                name={`contasInvestimentos[${ind}].numeroConta`}
                                                                label={LABEL.numeroConta}
                                                                value={item.numeroConta || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.numeroConta}
                                                            />
                                                        </GridItem6>
                                                        <GridItem6>
                                                            {!values.jsonAcessoCliente.acessoCliente && (
                                                                <TextValidatorText
                                                                    name={`contasInvestimentos[${ind}].codigoAgente`}
                                                                    label={LABEL.codigoAgente}
                                                                    value={item.codigoAgente || ''}
                                                                    onChange={handleChange}
                                                                    tamMax={TAMMAX.codigoAgente}
                                                                />
                                                            )}
                                                        </GridItem6>
                                                    </GridContainer>
                                                )}
                                            </GridItem7>
                                            <GridItem1>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem12>
                                </GridContainer>
                            )
                            : 
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    <GridContainer>
                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirContaInvestimentos} 
                            onClick={() => 
                                arrayHelpers.push({
                                    familiar: familiar
                                })
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default CadastroFormContaInvestimentos